import { Suspense } from 'react'
import './App.css'
import '/node_modules/bootstrap/dist/js/bootstrap.js'
import '/node_modules/bootstrap/dist/css/bootstrap.css'
import './assets/styles/assets/Assets.css'
import './assets/styles/assets/Dashboard.css'
import './assets/styles/sidebar/Sidebar.css'
import './assets/styles/header/Header.css'
import './assets/styles/user_login/UserLogin.css'
import './assets/styles/master/Customer.css'
import './assets/styles/chat/ChatWidget.css'
import 'react-toastify/dist/ReactToastify.css'
import Routes from './routes/Route'
import FallbackPage from './routes/auth/FallbackPage'
import { useRoutes } from 'react-router'
import { ToastContainer } from 'react-toastify'
import ChatWidget from './components/Chat/ChatWidget.jsx'

function App() {

  function RouteLayout({ path }) {
    const element = useRoutes(path);
    return element;
  }

  return (
    <div className="App">

      <Suspense fallback={<FallbackPage />}>
        <RouteLayout path={Routes()} />
      </Suspense>
      <ToastContainer />
      {/* <ChatWidget /> */}

    </div>
  );
}

export default App;
